import { useEffect, useState } from "react";
import { useApp } from "../../context/AppContext";
import { hasSeenBirthdayPriming, markBirthdayPrimingSeen } from "../../storage/session";
import { requestNotificationPermission } from "../../utils/notifications";
import { ModalSheet } from "../shared/ModalSheet";

export function BirthdayPrimingModal() {
  const { isUnlocked, upcomingEvents } = useApp();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isUnlocked || hasSeenBirthdayPriming()) return;
    const timer = window.setTimeout(() => setOpen(true), 1500);
    return () => clearTimeout(timer);
  }, [isUnlocked]);

  const enable = async () => {
    markBirthdayPrimingSeen();
    await requestNotificationPermission();
    setOpen(false);
  };

  const skip = () => {
    markBirthdayPrimingSeen();
    setOpen(false);
  };

  const upcoming = upcomingEvents.filter((e) => e.kind === "birthday" && !e.is_deceased).slice(0, 2);

  return (
    <ModalSheet open={open} onClose={skip} title="Birthday reminders" dismissOnBackdrop={false}>
      <p>
        Get a heads-up when family birthdays are coming up — never miss a chance to reach out.
      </p>
      {upcoming.length > 0 ? (
        <ul className="muted">
          {upcoming.map((e) => (
            <li key={e.id}>{e.label}</li>
          ))}
        </ul>
      ) : null}
      <button type="button" className="btn-primary" onClick={() => void enable()}>
        Turn on reminders
      </button>
      <button type="button" className="btn-ghost" onClick={skip}>
        Not now
      </button>
    </ModalSheet>
  );
}
